import React from "react";
import ItemsHorizontalScroll from "../../shared/itemsHorizontalScroll/itemsHorizontalScroll";
import UseSquadflixNavigate from "../useSquadflixNavigate";
import ItemBackdropDetails from "../../shared/item-backdrop-details/item-backdrop-details";
import useUserPreferences from "../../../user-app-config/hooks/use-user-preferences";
import SquadflixRowTitle from "../squadflixRowTitle/squadflixRowTitle";
import {useIntl} from "react-intl";
import {useContinueWatchingData} from "../../hooks/useCatalogRowData";

type Props = SquadflixRowsBaseProps & {
    onEpisodeClick?: (item: any) => void;
    customTitle?: React.ReactNode;
}

const ContinueWatchingRow = (props: Props) => {
    const {onEpisodeClick, order, customTitle} = props;
    const {episodes, loading} = useContinueWatchingData();
    const squadflixNav = UseSquadflixNavigate({});
    const {userPreferences, loading: loadingPreferences} = useUserPreferences();
    const intl = useIntl();

    if (loading) return null;
    if (!episodes || episodes.length === 0) return null;

    return (
        <div style={{height: "fit-content", overflow: "hidden", order: order ?? 0}}>
            <SquadflixRowTitle {...props}
                               title={customTitle ?? intl.formatMessage({id: "squadflix-home.continue-watching"})}
                               icon={<i className="fa-solid fa-tv"></i>}/>
            <ItemsHorizontalScroll>
                <div className="d-flex flex-row gap-3" style={{paddingLeft: "13px", paddingRight: "13px"}}>
                    {episodes.map((item) => {
                        if (item.air_date) {
                            const airDate = new Date(item.air_date);
                            const now = new Date();
                            if (airDate > now) {
                                return null;
                            }
                        }
                        const isSpoiler = (userPreferences.hideSpoilers || userPreferences.hideSpoilers == null || loadingPreferences) && !item.view;

                        return (<div key={item.id}>
                            <ItemBackdropDetails
                                onClickPoster={() => onEpisodeClick ? onEpisodeClick(item) : squadflixNav.navigateToEpisode(item)}
                                onClickDetails={() => squadflixNav.navigateToSerie(item.serie)}
                                style={{
                                    width: "min(300px, 59vw)",
                                    position: "relative",
                                }}
                                overlay={{
                                    center: <i className="fa-solid fa-play fa-xl" style={{
                                        padding: "10px 7px",
                                    }}></i>
                                }}
                                tmdbSrc={item.serie.backdrop_path}
                                detailsInfo="Ver el siguiente episodio"
                                detailsTitle={item.serie.name}
                                detailsSubtitle={isSpoiler ? `Temporada ${item.season_number} Episodio ${item.episode_number}` : `S${item.season_number}:E${item.episode_number} - ${item.name}`}
                            />
                        </div>)
                    })}
                </div>
            </ItemsHorizontalScroll>
        </div>
    );
};

export default ContinueWatchingRow;
